const mutations = {
  setSignedIn(state, signedIn) {
    state.signedIn = signedIn;
  },
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken;
  },
  setIsSessionActive(state, isSessionActive) {
    state.isSessionActive = isSessionActive;
  },
  setLoginTime(state, loginTime) {
    state.loginTime = loginTime;
  },
  setIsReminded(state, isReminded) {
    state.isReminded = isReminded;
  },
  setWasIdle(state, wasIdle) {
    state.wasIdle = wasIdle;
  },
  setIsManuallySignedOut(state, isManuallySignedOut) {
    state.isManuallySignedOut = isManuallySignedOut;
  },
  setAuthErrors(state, error) {
    state.errors = error;
  },
  setConfigurationDataProperties(state, configurationData) {
    state.sessionExpirationMaxTime = configurationData.idpMaxAbsoluteSession;
    state.beforeSessionExpirationMaxNotificationTime =
      configurationData.idpBeforeAbsoluteSessionNotificationTime;
    state.idleTime = configurationData.idpSessionIdleTime;
  },
  setAnyActiveTab(state, isActive) {
    state.anyActiveTab = isActive;
  },
  setOriginToken(state, originToken) {
    state.originToken.accessToken = originToken.accessToken;
    state.originToken.refreshToken = originToken.refreshToken;
  },
  setIsLoginError(state, isLoginError) {
    state.isLoginError = isLoginError;
  },
  setTokenCheck(state, tokenCheck) {
    state.tokenCheck = tokenCheck;
  }
};

export default mutations;
